<section class="container-capped px-0">
  <ng-container *ngIf="!favorites?.length">
    <div class="kp-message kp-message-info">
      شما هیچ آگهی <i class="far fa-bookmark"></i> نشان شده‌ای نداری.<br />
      در هنگام جستجوی آگهی‌ها هر آگهی که به نظرت جالب بود رو می‌تونی برای بررسی بیشتر <i class="fa fa-bookmark"></i>
      نشان
      کنی.
    </div>
    <div class="kp-card">
      <app-search-box></app-search-box>
    </div>
  </ng-container>

  <div class="kp-card pointer relative" [class.white-bg]="!favorite.IsExpired" [class.gray-bg]="favorite.IsExpired"
    [class.f-white]="favorite.IsExpired" *ngFor="let favorite of favorites; let i=index">
    <ngx-spinner [name]="favorite.Id" [fullScreen]="false" size="small" type="timer"></ngx-spinner>
    <div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="badge badge-kp py-0 px-1 light-gray-bg f-initial fs-xs">
          تاریخ انقضا: {{favorite.ExpirationTime|pdate:true}}
        </div>
      </div>
      <h5 [routerLink]="['/job', favorite.ItemId]">
        {{favorite.Item.title}}
      </h5>
      <div class="fs-sm" *ngIf="favorite.Item.company">{{favorite.Item.company}}</div>
      <div class="fs-sm" *ngIf="favorite.Item.state">{{[favorite.Item.state, favorite.Item.city].join('،')}}</div>
      <div class="text-left">
        <button class="btn btn-secondary btn-sm" (confirm)="remove(favorite,$event);">
          <i class="fa fa-trash-alt ml-1"></i>
          حذف
        </button>

        <a class="btn btn-secondary btn-sm mr-2" [routerLink]="['/job', favorite.ItemId]" *ngIf="!favorite.IsExpired">
          <i class="fa fa-eye ml-1"></i>
          نمایش آگهی
        </a>
      </div>
    </div>
  </div>
</section>